import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const userData = params.get('user');

    if (token && userData) {
      // Stocker le token dans le localStorage
      localStorage.setItem('compte_visiteur', token);
      
      // Stocker les données utilisateur dans le localStorage
    //   localStorage.setItem('user', userData);

      // Rediriger vers la page d'accueil ou le tableau de bord
      navigate('/');
    } else {
      // En cas d'erreur, rediriger vers la page de connexion
      const error = params.get('error');
      navigate('/login', { state: { error } });
    }
  }, [location, navigate]);

  return (
    <div>
      <h2>Connexion en cours...</h2>
    </div>
  );
};

export default AuthCallback;